import request from '@/utils/server'

// 新增设备配件
export function addModelLinkAccessories(data) {
    return request({
      url: '/device/addModelLinkAccessories',
      method: 'POST',
   data:data
    })
  }
//   获取设备配件
export function getModelLinkAccessories(query) {
    return request({
      url: '/device/getModelLinkAccessories',
      method: 'get',
      params:query
    })
  }
  
// 删除设备配件
export function delModelLinkAccessories(data) {
    return request({
      url: '/device/delModelLinkAccessories',
      method: 'POST',
   data:data
    })
  }
  // 修改·
  export function editModelLinkAccessories(data) {
    return request({
      url: '/device/editModelLinkAccessories',
      method: 'POST',
   data:data
    })
  }